export const Solito = ({ children }) => <>{children}</>
